module.exports = __webpack_public_path__ + "img/6.01f07cf8.jpg";